import {
  IconContract,
  IconInfoCircle,
  IconTicket,
  IconCalendarStats,
} from "@tabler/icons-react";
import { SimpleGrid, Flex } from "@mantine/core";
import StatCard from "./StatCard";

function RegistrationSummary({ data, isPending }) {
  const {
    approved = 0,
    pending = 0,
    invoiced = 0,
    totalTickets = 0,
    approvedTickets = 0,
    processingTickets = 0,
    maxCapacity = null,
    todayRegistrations = 0,
    weekRegistrations = 0,
    monthRegistrations = 0,
  } = data || {};

  const statCards = [
    {
      title: "Registrations",
      icon: <IconContract size={24} />,
      color: "blue",
      details: [
        { label: "Approved", value: approved, color: "green" },
        { label: "Invoiced", value: invoiced, color: "orange" },
        { label: "Pending", value: pending, color: "yellow" },
      ],
      capacity: maxCapacity,
      approvedTickets,
      tooltip: {
        text: "This overview doesn't include rejected registrations",
        icon: <IconInfoCircle size={18} />,
      },
    },
    {
      title: "Tickets",
      icon: <IconTicket size={24} />,
      color: "violet",
      details: [
        { label: "Total", value: totalTickets },
        { label: "Issued", value: approvedTickets, color: "green" },
        {
          label: "Processing",
          value: processingTickets,
          color: "gray",
        },
      ],
      tooltip: {
        text: "This overview doesn't include rejected registrations. Processing tickets are those that are either pending or invoiced.",
        icon: <IconInfoCircle size={18} />,
      },
    },
    {
      title: "Recent Activity",
      icon: <IconCalendarStats size={24} />,
      color: "green",
      details: [
        { label: "Today", value: todayRegistrations, color: "blue" },
        { label: "This Week", value: weekRegistrations, color: "green" },
        { label: "This Month", value: monthRegistrations, color: "gray" },
      ],
      tooltip: {
        text: "Total registrations created in each time period (including all statuses)",
        icon: <IconInfoCircle size={18} />,
      },
    },
  ];

  if (isPending) {
    return (
      <Flex py="md" w="100%">
        <SimpleGrid cols={{ lg: 3, md: 2, sm: 1 }} spacing="lg" w="100%">
          {[0, 1, 2].map((index) => (
            <StatCard key={index} loading />
          ))}
        </SimpleGrid>
      </Flex>
    );
  }

  return (
    <Flex py="md" w="100%">
      <SimpleGrid cols={{ lg: 3, md: 2, sm: 1 }} spacing="lg" w="100%">
        {statCards.map((stat, index) => (
          <StatCard key={index} stat={stat} />
        ))}
      </SimpleGrid>
    </Flex>
  );
}

export default RegistrationSummary;
